import dayjs from 'dayjs';
import { t } from 'i18next';
import { atom } from 'recoil';

export const notificationsAtom = atom({
  key: 'notifications',
  default: [],
});

export const userAtom = atom({
  key: 'user',
  default: null,
});

export const isLoggingInAtom = atom({
  key: 'isLoggingIn',
  default: false,
});

export const tokenAtom = atom({
  key: 'token',
  default: null,
});

export const alertAtom = atom({
  key: 'alert',
  default: {
    show: false,
    title: '',
    content: '',
    onClick: null,
  },
});

export const stateAtom = atom({
  key: 'currentState',
  default: null,
});

export const menuSideBarAtom = atom({
  key: 'menuSideBar',
  default: false,
});

export const mainPageInitializeAtom = atom({
  key: 'mainPageInitialize',
  default: true,
});

export const userPrivilagesAtom = atom({
  key: 'userPrivilages',
  default: { },
});

export const userOperatorsAtom = atom({
  key: 'userOperators',
  default: []
});

export const reloadSpecialServicesAtom = atom({
  key: 'reloadSpecialServices',
  default: false
});

export const dashboardAnalyticsHeaderAtom = atom({
  key: 'dashboardAnalyticsHeader',
  default: {
    routeId: '',
    operatorId: '',
    start: dayjs().startOf('week').format('MMM DD, YYYY'),
    end: dayjs().endOf('week').format('MMM DD, YYYY'),
    loading: false,
  }
});

export const dashboardAnalyticsDataAtom = atom({
  key: 'dashboardAnalyticsData',
  default: {
    routes: [],
    operators: [{ operatorId: '', operatorName: t('any') }],
  }
});

export const dashboardAnalyticsLoadedAtom = atom({
  key: 'dashboardAnalyticsLoaded',
  default: {
    page1: false,
    page2: false,
    page3: false
  }
});

export const dashboardAnalyticsShouldLoadAtom = atom({
  key: 'dashboardAnalyticsShouldLoad',
  default: {
    page1: false,
    page2: false,
    page3: false
  }
});

export const amaDashboardShowMphAtom = atom({
  key: 'amaDashboardShowMph',
  default: true
});

export const amaDashboardCurrentTabAtom = atom({
  key: 'amaDashboardCurrentTab',
  default: '1'
});

export const pipelineHealthCurrentTabAtom = atom({
  key: 'pipelineHealthCurrentTab',
  default: '1'
});

export const amaDashboardLiveMapSettingsAtom = atom({
  key: 'amaDashboardLiveMapSettings',
  default: {
    type: 'roadmap', // hybrid
    showTraffic: false
  }
});
